module.exports = __webpack_public_path__ + "static/media/rehab.f68c495b.jpg";